module.exports = __webpack_public_path__ + "img/pic2.7ccb2fe2.png";